export default "__VITE_ASSET__C_pLL4N0__"